import { render, staticRenderFns } from "./TaskGroupShowModal.vue?vue&type=template&id=273ee2be&"
import script from "./TaskGroupShowModal.vue?vue&type=script&lang=ts&"
export * from "./TaskGroupShowModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports